import { render, staticRenderFns } from "./PPMBin.vue?vue&type=template&id=9032c5c4&scoped=true"
import script from "./PPMBin.vue?vue&type=script&lang=ts"
export * from "./PPMBin.vue?vue&type=script&lang=ts"
import style0 from "./PPMBin.vue?vue&type=style&index=0&id=9032c5c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9032c5c4",
  null
  
)

export default component.exports